import { DropdownItem } from '@/common/components';
import { TimezoneId } from './timezones';

export const stateOptions: DropdownItem[] = [
  { id: 'AL', label: 'Alabama', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'AK', label: 'Alaska', optionType: TimezoneId.AMERICA_ANCHORAGE },
  { id: 'AZ', label: 'Arizona', optionType: TimezoneId.AMERICA_PHOENIX },
  { id: 'AR', label: 'Arkansas', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'CA', label: 'California', optionType: TimezoneId.AMERICA_LOS_ANGELES },
  { id: 'CO', label: 'Colorado', optionType: TimezoneId.AMERICA_DENVER },
  { id: 'CT', label: 'Connecticut', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'DE', label: 'Delaware', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'FL', label: 'Florida', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'GA', label: 'Georgia', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'HI', label: 'Hawaii', optionType: TimezoneId.PACIFIC_HONOLULU },
  { id: 'ID', label: 'Idaho', optionType: TimezoneId.AMERICA_DENVER },
  { id: 'IL', label: 'Illinois', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'IN', label: 'Indiana', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'IA', label: 'Iowa', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'KS', label: 'Kansas', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'KY', label: 'Kentucky', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'LA', label: 'Louisiana', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'ME', label: 'Maine', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'MD', label: 'Maryland', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'MA', label: 'Massachusetts', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'MI', label: 'Michigan', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'MN', label: 'Minnesota', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'MS', label: 'Mississippi', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'MO', label: 'Missouri', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'MT', label: 'Montana', optionType: TimezoneId.AMERICA_DENVER },
  { id: 'NE', label: 'Nebraska', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'NV', label: 'Nevada', optionType: TimezoneId.AMERICA_LOS_ANGELES },
  { id: 'NH', label: 'New Hampshire', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'NJ', label: 'New Jersey', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'NM', label: 'New Mexico', optionType: TimezoneId.AMERICA_DENVER },
  { id: 'NY', label: 'New York', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'NC', label: 'North Carolina', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'ND', label: 'North Dakota', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'OH', label: 'Ohio', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'OK', label: 'Oklahoma', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'OR', label: 'Oregon', optionType: TimezoneId.AMERICA_LOS_ANGELES },
  { id: 'PA', label: 'Pennsylvania', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'RI', label: 'Rhode Island', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'SC', label: 'South Carolina', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'SD', label: 'South Dakota', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'TN', label: 'Tennessee', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'TX', label: 'Texas', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'UT', label: 'Utah', optionType: TimezoneId.AMERICA_DENVER },
  { id: 'VT', label: 'Vermont', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'VA', label: 'Virginia', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'WA', label: 'Washington', optionType: TimezoneId.AMERICA_LOS_ANGELES },
  { id: 'WV', label: 'West Virginia', optionType: TimezoneId.AMERICA_NEW_YORK },
  { id: 'WI', label: 'Wisconsin', optionType: TimezoneId.AMERICA_CHICAGO },
  { id: 'WY', label: 'Wyoming', optionType: TimezoneId.AMERICA_DENVER }
];
